import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import { SubNav } from "./subnav";

export interface RoadmapSubNavProps {
    className?: string;
}

export const RoadmapSubNav = ({ className }: RoadmapSubNavProps) => {
    const intl = useIntl();

    const ROADMAP_NAV_CONFIG = {
        heading: {
            label: intl.formatMessage({
                id: "roadmapSubNav.heading",
                defaultMessage: "Roadmaps"
            }),
            linkUrl: useLocalizedHref("/roadmap/cloud")
        },
        navItems: [
            {
                label: intl.formatMessage({
                    id: "roadmapSubNav.cloud",
                    defaultMessage: "Cloud"
                }),
                linkUrl: useLocalizedHref("/roadmap/cloud")
            },
            {
                label: intl.formatMessage({
                    id: "roadmapSubNav.dataCenter",
                    defaultMessage: "Data Center"
                }),
                linkUrl: useLocalizedHref("/roadmap/data-center")
            }
        ],
        cta: {
            label: intl.formatMessage({
                id: "roadmapSubNav.exploreMigration",
                defaultMessage: "Explore how to migrate"
            }),
            linkUrl: "/migration"
        }
    } as const;
    return (
        <SubNav
            headingLabel={ROADMAP_NAV_CONFIG.heading.label}
            headingLinkUrl={ROADMAP_NAV_CONFIG.heading.linkUrl}
            navItems={ROADMAP_NAV_CONFIG.navItems.map((item) => ({
                label: item.label,
                linkUrl: item.linkUrl
            }))}
            cta={{
                label: ROADMAP_NAV_CONFIG.cta.label,
                linkUrl: ROADMAP_NAV_CONFIG.cta.linkUrl
            }}
            className={className}
        />
    );
};

RoadmapSubNav.displayName = "RoadmapSubNav";
